<template>
    <div class="row mx-0">
        <div 
            class="col-lg-3 col-md-4 col-sm-12"
            :class="{'pr-0' : $breakpoint.lgAndDown && !$breakpoint.smAndDown}"
        >
            <all-negotiations />
        </div>
        <div class="col-lg-9 col-md-8 col-sm-12">
            <div class="d-flex flex-column align-items-end">
                <refresh-information/>
                <button 
                    class="btn btn-primary"
                    :class="[ $breakpoint.smAndDown ? 'btn-icon btn-new--mobile' : ' mt-2 mb-2']"
                    :disabled='getIsPlatformClosed' @click="startNegotiation()">
                    <i v-if="$breakpoint.smAndDown" class="fas fa-plus" icon="plus" />
                    <span v-else>Start Negotiation</span>
                </button>
            </div>
            <div class="modal right fade" v-if="$breakpoint.smAndDown" id="myNegotiation" tabindex="-1" role="dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <button class="modal-close" data-dismiss="modal" aria-label="Close">
                            <i class="fas fa-lg fa-times"></i>
                        </button> 
                        <negotiation-content />
                    </div>
                </div>
            </div>
            <div v-else>
                <negotiation-content />
            </div>
        </div>
    </div>
</template>

<script>
import breakpoint from '@/mixins/index';
import { mapGetters, mapState, mapActions } from 'vuex'

import AllNegotiations from '@/components/Negotiations/buyer/AllNegotiations.vue'
import NegotiationContent from '@/components/Negotiations/buyer/NegotiationContent.vue'
import RefreshInformation from '@/components/RefreshInformation.vue';

export default {
    mixins: [breakpoint],
    components: {
        AllNegotiations,
        NegotiationContent,
        RefreshInformation
    },
    computed: {
        ...mapGetters('buyerOpen', ['getIsPlatformClosed']),
        ...mapState('negotiation', ['showStartNegotiation', 'negotiationUnavailableWindowShown']),
        openStartNegotiation: function(){
            if (this.showStartNegotiation){
                let element = this.$root.$refs.startNegotiation.$el
                $(element).modal({backdrop: 'static', keyboard: false})
            }
        },
        openModal: function(){
            if (this.negotiationUnavailableWindowShown){
                let element = this.$root.$refs.negotiationUnavailable.$el
                $(element).modal({backdrop: 'static', keyboard: false})
            }
        }
    },
    watch: {
        openStartNegotiation(){},
        openModal(){}
    },
    methods: {
        ...mapActions('negotiation', ['updateShowStartNegotiation']),
        startNegotiation: function(){
            this.updateShowStartNegotiation(true)
        }
    },
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/components/_modals.scss";
</style>
